import * as api from  './api'
import * as reducers from './slice-reducers'
import { ProjectOption } from 'src/core/models'
import { AppDispatch } from 'src/app/store'

export const getProjectOptionList = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setProjectOptionsLoading(true))
    const data: ProjectOption[] = await api.getProjectOptionsListtAPI()
    dispatch(reducers.setProjectOptionsList(data))
    dispatch(reducers.setProjectOptionsLoading(false))
  }catch (error){
    dispatch(reducers.setProjectOptionsLoading(false))
  }
}
